<template lang="pug">
  #faqdoc
    h1 faq
</template>

<script type="text/babel">
  export default {

  }
</script>



// WEBPACK FOOTER //
// FaqDoc.vue?d84ca45e